import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { colors } from "../theme/theme";
import { formOptions } from "../utils/Data";

interface radioInputProps {
  label: string;
  value: string | number;
  disabled?: boolean;
  onchange?: (value: string) => void;
}
const RadioInput: React.FC<radioInputProps> = ({
  label,
  value,
  disabled,
  onchange,
  ...props
}) => {
  return (
    <div className="form-field">
      {label && (
        <Typography
          className="typography-text"
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontSize: "12px",
            fontWeight: 400,
            color: colors.primary,
            width: "80%",
          }}
          variant="subtitle2"
        >
          {label}
        </Typography>
      )}
      <FormControl
        component="fieldset"
        margin="normal"
        size="small"
        sx={{
          marginBottom: "0px",
          marginTop: "8px",
          "& .MuiFormControlLabel-label": {
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: '"Inter", sans-serif',
          },
        }}
      >
        <RadioGroup
          row
          value={value}
          onChange={(e) => onchange && onchange(e.target.value)}
        >
          {formOptions.yesNo.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio size="small" disabled={disabled} />}
              label={option}
              sx={{ marginRight: 2 }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default RadioInput;
